export default {
    reloadIfHttpsAvailable: function () {

        //if already on https, skip this check
        if (window.location.protocol === 'https:') {
            return;
        }

        var prefetchImg = document.querySelectorAll('.prefetch_img');

        //reload page  if prefetch image from https is loaded (it means https is available)
        function prefetchLoaded() {
            window.location = window.location.href.replace(/^http:/, 'https:');
        }

        for(var i = 0; i < prefetchImg.length; i ++) {
            if (prefetchImg[i].complete && prefetchImg[i].naturalWidth > 0) {
                prefetchLoaded();
            } else {
                prefetchImg[i].addEventListener('load', prefetchLoaded);
            }
        }
    }
};
